import {Images} from "../../../../images/Images.jsx";
import {isEmpty} from "lodash";

export const carType = {
    car: "car"
};

export const ImagesByCarType = {
    [carType.car]: Images.carDeliveryIcon
};

export const DeliveryProviderFormFields = {
    name: "name",
    email: "email",
    contactName: "contactName",
    paymentTerms: "paymentTerms",
    phone: "phone",
    idNumber: "idNumber",
    licenseNumber: "licenseNumber"
};

export const DeliveryProviderFormFieldsValidationRules = {
    [DeliveryProviderFormFields.name]: name => {
        if (isEmpty(name)) {
            return "שדה חובה";
        }
    },
    [DeliveryProviderFormFields.paymentTerms]: paymentTerms => {
        if (!paymentTerms) {
            return "שדה חובה";
        }
    },
    [DeliveryProviderFormFields.contactName]: contactName => {
        if (isEmpty(contactName)) {
            return "שדה חובה";
        }
    },
    [DeliveryProviderFormFields.phone]: phone => {
        if (isEmpty(phone)) {
            return "שדה חובה";
        }
    },
    [DeliveryProviderFormFields.email]: email => {
        if (isEmpty(email)) {
            return "שדה חובה";
        }
    },
    [DeliveryProviderFormFields.idNumber]: idNumber => {
        if (isEmpty(idNumber)) {
            return "שדה חובה";
        }
    },
    [DeliveryProviderFormFields.licenseNumber]: licenseNumber => {
        if (isEmpty(licenseNumber)) {
            return "שדה חובה";
        }
    }
};

export const defaultDeliveryProviderPricing = {
    initialPrice: 70,
    additionalPricePerUnitDistance: 2,
    unitDistance: 1,
    distanceThreshold: 1,
    maxPrice: 320
};
